import { gql, TypedDocumentNode } from '@apollo/client';
import { NUMOCOOrderTerms, PurchaseOrder } from './po-queries';

export interface SavedPODetails {
  purchaseOrders: PurchaseOrder[];
  lineItems: { _id: string; poNumber: string }[];
  errors?: { code: string; message: string }[];
}

interface AdminSubmitPurchaseOrdersResult {
  adminSubmitPurchaseOrders: SavedPODetails;
}

export const AdminSubmitPurchaseOrders: TypedDocumentNode<
  AdminSubmitPurchaseOrdersResult,
  { exportRunId: string; poNumbers: { poNumber: string; transactionIds: string[] }[] }
> = gql`
  mutation adminSubmitPurchaseOrders($exportRunId: String!, $poNumbers: [PurchaseOrderInputType]!) {
    adminSubmitPurchaseOrders(exportRunId: $exportRunId, poNumbers: $poNumbers) {
      purchaseOrders {
        _id
        isVendorOfRecord
        status
        poDueDate
        poNumber
      }
      lineItems {
        _id
        poNumber
      }
      errors {
        code
        message
      }
    }
  }
`;

interface AdminCreateNumocoOrderResult {
  adminCreateNumocoOrder: {
    purchaseOrder: {
      _id: string;
      externalOrderId: string;
      status: string;
    };
    errors: {
      code: string;
      message: string;
    }[];
  };
}

export const AdminCreateNumocoOrder: TypedDocumentNode<
  AdminCreateNumocoOrderResult,
  { purchaseOrderId: string; orderTerms: NUMOCOOrderTerms }
> = gql`
  mutation adminCreateNumocoOrder($purchaseOrderId: String!, $orderTerms: AdminNumocoOrderTermsInput!) {
    adminCreateNumocoOrder(purchaseOrderId: $purchaseOrderId, orderTerms: $orderTerms) {
      purchaseOrder {
        _id
        externalOrderId
        status
      }
      errors {
        code
        message
      }
    }
  }
`;
